/* ==========================================================================
   sections-d.js — Stack Value countdown timer
   Scoped to [data-stack-countdown]. FAQ accordion needs no JS (native
   <details>/<summary>). Guarantee, Reassurance and Footer are static markup.
   ========================================================================== */
(function () {
  var timers = document.querySelectorAll('[data-stack-countdown]');
  if (!timers.length) return;

  timers.forEach(function (el) {
    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 15;
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minutesEl = el.querySelector('[data-countdown-minutes]');
    var secondsEl = el.querySelector('[data-countdown-seconds]');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    var totalSeconds = minutes * 60;
    var target = Date.now() + totalSeconds * 1000;

    function pad(num) {
      return num.toString().padStart(2, '0');
    }

    function render(remainingSeconds) {
      var h = Math.floor(remainingSeconds / 3600);
      var m = Math.floor((remainingSeconds % 3600) / 60);
      var s = remainingSeconds % 60;
      hoursEl.textContent = pad(h);
      minutesEl.textContent = pad(m);
      secondsEl.textContent = pad(s);
    }

    render(totalSeconds);

    var interval = setInterval(function () {
      var remaining = Math.max(0, Math.round((target - Date.now()) / 1000));
      render(remaining);
      if (remaining <= 0) {
        clearInterval(interval);
      }
    }, 1000);
  });
})();
